import { render, staticRenderFns } from "./ItemMasterTagsDocumentsSection.vue?vue&type=template&id=60b44664&scoped=true&"
import script from "./ItemMasterTagsDocumentsSection.vue?vue&type=script&lang=js&"
export * from "./ItemMasterTagsDocumentsSection.vue?vue&type=script&lang=js&"
import style0 from "./ItemMasterTagsDocumentsSection.vue?vue&type=style&index=0&id=60b44664&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b44664",
  null
  
)

export default component.exports